// extracted by mini-css-extract-plugin
module.exports = {"product":"N_dh","product__image":"N_dj","product__featured":"N_dk","product__prices":"N_c0","product__prices__sale":"N_dl","product__title":"N_cW","product__title__sale":"N_dm"};